export default __webpack_public_path__ + "static/media/fourth-visual.0f557ead.png";